<template>
  <div class="pages-content ContactContent">
    <div class="pages-about-gywm">
      <div class="pages-about-gywm-tdgl">
        <h1>
          {{$t("ContactTitle")}}
        </h1>
        <ul class="gywm-rdgl">
          <li
            v-for="(val,index) in ContactContentS"
            :key="index"
          >
            <h2 class="lxwm-h2">
              {{val.Project}}
            </h2>
            <p
              class="gywm-rdgl-p-text text"
              :style="{'margin-bottom':'30px'}"
              ref="text"
              v-html="val.ProjectIntroduce"
            >
            </p>
            <p class="gywm-rdgl-p-text-mailto">
              <i class="icon"></i>
              <!-- <em>Email：</em> -->
              <a
                :href="'mailto:'+val.Mail[0].link"
                target="_blank"
              >
                {{val.Mail[0].name}} {{val.Mail[0].link}}
              </a>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import { ContactContent } from './js/ContactContent';
export default {
  name: 'ContactContent',
  data() {
    return {
      // ContactContent: ContactContent
      // show: false,
    }
  },
  computed: {
    ContactContentS() {
      return this.$t('ContactContent')
    },
  },
}
</script>

<style scoped>
@import './style/Contact.min.css';
</style>



// WEBPACK FOOTER //
// src/components/contact/ContactContent.vue